import { render, staticRenderFns } from "./virtualForm.vue?vue&type=template&id=5ac93c3c&scoped=true"
import script from "./virtualForm.vue?vue&type=script&lang=js"
export * from "./virtualForm.vue?vue&type=script&lang=js"
import style0 from "./virtualForm.vue?vue&type=style&index=0&id=5ac93c3c&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac93c3c",
  null
  
)

export default component.exports